var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSucceed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_144833",
    "data-name": "Group 144833",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.231,
    height: 69.231,
    viewBox: "0 0 69.231 69.231",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    fill: "none",
    stroke: "#32ad45",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.615,
    cy: 34.615,
    rx: 34.615,
    ry: 34.615,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.615,
    cy: 34.615,
    rx: 33.115,
    ry: 33.115,
    fill: "none"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1276",
    "data-name": "Path 1276",
    d: "M.2,0,0,13.678l36.167.7",
    transform: "translate(17.961 37.035) rotate(-45)",
    fill: "none",
    stroke: "#32ad45",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucceed);
export default __webpack_public_path__ + "static/media/Succeed.0cb88aee0e95c9848f2c2c63decb7ed4.svg";
export { ForwardRef as ReactComponent };